<template>
  <div id="wrapper">
    <!-- Sidebar -->
    <SideBarMenu />
    <!-- /#sidebar-wrapper -->
    <HeaderBarMenu v-bind:title="pageTitle" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row filter-row row-background-color" style="padding: 10px">
          <div class="col-sm mobile-small-bottom">
            <SelectorShip v-bind:shipInventorylist="options" ref="emsshipselect" @changedSelect="changeShip" />
          </div>
          <div class="col-sm mobile-small-bottom">
            <VueCtkDateTimePicker label="Select date and time" format="YYYY-MM-DD HH:mm" v-model="dateValueFrom"
              dark="true" id="1" />
          </div>
          <div class="col-sm mobile-small-bottom">
            <VueCtkDateTimePicker label="Select date and time" format="YYYY-MM-DD HH:mm" v-model="dateValueTo"
              dark="true" id="2" />
          </div>
          <div class="col-sm">
            <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
              <button class="modal__close" @click="showModal = false">
                <mdi-close>
                  <img src="../assets/modal-close-button.svg" />
                </mdi-close>
              </button>
              <span class="modal__title">{{ this.modalTitle }}</span>
              <div class="modal__content">
                <p v-for="item in this.errorList" :key="item">- {{ item }}</p>
              </div>
            </vue-final-modal>
            <button type="button" class="btn btn-primary w-100" @click="submitForm">
              Apply Filter
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <EmsMonitorTable v-bind:reports="this.emsList.Reports" @changedSelect="selectedTableRow" />
          </div>
        </div>

        <FAB v-bind:filer="this.emsList.Reports" :excelFile="this.testaki" :screen="this.pageTitle"
          :dateValueTo="this.dateValueTo" :dateValueFrom="this.dateValueFrom" />
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>

<script>
import MonitorService from "../services/monitor.service";
import ShipService from "../services/ship.service";
import SideBarMenu from "../components/SideBarMenu.vue";
import HeaderBarMenu from "../components/HeaderBarMenu.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import SelectorShip from "../components/SelectorShip";
import EmsMonitorTable from "../components/EmsMonitorTable.vue";
import UtilityService from "../services/utility.service";
import FAB from "../components/FAB.vue";
import TokenService from "../services/token.service";
import CacheService from "@/services/cache.service";
export default {
  name: "MonitorDashboard",
  components: {
    SideBarMenu,
    HeaderBarMenu,
    VueCtkDateTimePicker,
    SelectorShip,
    EmsMonitorTable,
    MonitorService,
    FAB,
    CacheService,
  },
  data() {
    return {
      exceFileToDownload: [], //todo
      showModal: false,
      pageTitle: "Monitor Dashboard",
      fromDate: null,
      toDate: null,
      dateValueFrom: null,
      dateValueTo: null,
      selectedShipID: 0,
      emsList: {},
      numOfRecords: 0,
      options: [],
      modalTitle: "",
      modalText: "",
      errorList: [],
      company: 0,
      cachedShipId: 0
    };
  },
  created() {
    let user = TokenService.getUser();
    this.company = user.company;
  },
  mounted() {

    let cache = CacheService.getFromCache("dateDetails");
    if (cache) {
      this.fromDate = cache.fromDate;
      this.toDate = cache.toDate;
      this.dateValueFrom = cache.dateValueFrom;
      this.dateValueTo = cache.dateValueTo;
      this.cachedShipId = cache.shipId;
    }
    else {
      this.fromDate = UtilityService.fromDateInit();
      this.toDate = UtilityService.toDateInit();
      this.dateValueFrom = UtilityService.fromDateInit();
      this.dateValueTo = UtilityService.toDateInit();
    }
    this.getShips();
  },
  methods: {
    assignShipDetails: function () {
      this.emsList.Reports.forEach((report) => {
        const shipDetails = this.options.find((option) => option.shipId === report.ShipId);
        if (shipDetails) {
          report.shipDetails = shipDetails.shipType;
        }
      });
    },

    //function that present errors from api
    showAPIError: function (title, value) {
      this.modalTitle = "Error: " + title;
      this.errorList = [];
      this.errorList.push(value);
      this.showModal = true;
    },
    //function that redirects to detail for selected ship
    selectedTableRow: function (value) {
      CacheService.saveToCache("dateDetails", {
        shipId: value.ShipId,
        dateValueFrom: this.dateValueFrom,
        dateValueTo: this.dateValueTo
      });
      this.$router.push({
        name: "MonitorDetail",
        params: { id: value.ShipId },
      });
    },
    //populates the table based on the selected options from the filters!
    browse: function () {
      if (this.selectedShipID == 10000) {
        MonitorService.getShipMonitorData(
          this.fromDateFinal,
          this.toDateFinal,
          this.company
        ).then(
          (response) => {
            this.emsList = response.data;


            //assigns the ship details to the reports
            this.assignShipDetails();

            this.numOfRecords = this.emsList.Reports.length;



            this.numOfRecords = this.emsList.Reports.length;
          },
          (error) => {
            this.showAPIError("Get Monitor Data", error);
            if (error.response && error.response.status === 401) {
              this.$store.dispatch("logout");
            }
          }
        );
      } else {
        MonitorService.getSingleShipMonitorData(
          this.fromDateFinal,
          this.toDateFinal,
          this.selectedShipID,
          this.company
        ).then(
          (response) => {
            this.emsList.Reports = [];
            this.emsList.Reports.push(response.data.Report);

            //assigns the ship details to the reports
            this.assignShipDetails();

            this.numOfRecords = 1;
          },
          (error) => {
            this.showAPIError("Get Monitor Data", error);
            if (error.response && error.response.status === 401) {
              this.$store.dispatch("logout");
            }
          }
        );
      }
    },
    //handles the users  filters`s selections
    submitForm: function () {

      // alert("submitForm")
      this.toDateFinal = this.dateValueTo;
      this.fromDateFinal = this.dateValueFrom;

      this.errorList = [];
      if (this.selectedShipID < 1 || this.selectedShipID == null) {
        this.errorList.push("You have to select a Vessel");
      }
      if (this.toDateFinal == null || this.toDateFinal == "") {
        this.errorList.push("You have to select an ending date.");
      }
      if (this.fromDateFinal == null || this.fromDateFinal == "") {
        this.errorList.push("You have to select a starting date.");
      }
      if (this.fromDateFinal > this.toDate) {
        this.errorList.push(
          "You can not select a future date for starting date."
        );
      }
      if (this.toDateFinal > this.toDate) {
        this.errorList.push(
          "You can not select a future date for ending date."
        );
      }
      if (this.toDateFinal < this.fromDateFinal) {
        this.errorList.push(
          "You have to select an arrival date greater than the departure date.\n"
        );
      }

      let dateToDateFinal = new Date(this.toDateFinal);
      let dateFromDateFinal = new Date(this.fromDateFinal);


      if (dateToDateFinal.getFullYear() !== dateFromDateFinal.getFullYear()) {
        this.errorList.push(
          "Both dates are not in the same year.CII requires dates to be in the same year.\n"
        );

      }
      if (this.errorList.length > 0) {
        this.modalTitle = "Error";
        this.showModal = true;
        return;
      } else {
        CacheService.saveToCache("dateDetails", {
          shipId: this.selectedShipID,
          dateValueFrom: this.dateValueFrom,
          dateValueTo: this.dateValueTo
        });
        this.browse();
      }
    },

    //get ships available for the user
    getShips: function () {
      ShipService.getShipsAuth().then(
        (response) => {
          // alert(JSON.stringify(response));
          let arrayShipsTemp = response.data.ShipsBasicData;
          let selectedShips = [];

          //All Vessels
          let shipTemp = {};
          shipTemp.shipId = 10000;
          shipTemp.shipName = "All Vessels";
          shipTemp.shipType = "All Vessels";
          selectedShips.push(shipTemp);

          for (let i = 0; i < arrayShipsTemp.length; i++) {
            let shipTemp = {};

            shipTemp.shipId = arrayShipsTemp[i].ShipId;
            shipTemp.shipName = arrayShipsTemp[i].ShipName;
            shipTemp.shipType = arrayShipsTemp[i].ShipType;
            selectedShips.push(shipTemp);
          }

          this.options = selectedShips;

          let tempSelectedShip = selectedShips[0];

          if (this.cachedShipId > 0) {
            tempSelectedShip = selectedShips.find((ship) => ship.shipId === this.cachedShipId);
          }

          if (this.$refs.emsshipselect) {
            this.$refs.emsshipselect.value = tempSelectedShip
          }

          this.changeShip(tempSelectedShip);
          this.submitForm();
        },
        (error) => {
          this.showAPIError("Get Ships", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },

    //change ship selection
    changeShip: function (value) {
      if ((this.selectedShipID = null)) {
        this.selectedShipID = 0;
      } else {
        this.selectedShipID = value.shipId;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 50%;
  border-color: #2d3748;
  background-color: #1a202c;
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: #1b202c;
  border-color: #2d333d;
  border-style: solid;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>